export var createNativePeriodicWaveFactory = function createNativePeriodicWaveFactory(getBackupNativeContext) {
  return function (nativeContext, _ref) {
    var disableNormalization = _ref.disableNormalization,
        imag = _ref.imag,
        real = _ref.real;
    // Bug #50: Only Edge does currently not allow to create AudioNodes (and other objects) on a closed context yet.
    var backupNativeContext = getBackupNativeContext(nativeContext); // @todo Edge, Firefox & Safari do only accept Float32Arrays.

    var wrappedImag = new Float32Array(imag);
    var wrappedReal = new Float32Array(real);

    if (backupNativeContext !== null) {
      return backupNativeContext.createPeriodicWave(wrappedReal, wrappedImag, {
        disableNormalization: disableNormalization
      });
    }

    return nativeContext.createPeriodicWave(wrappedReal, wrappedImag, {
      disableNormalization: disableNormalization
    });
  };
};